

<template>
  <div class="pc-detail-content">
    <div class="product-info">
      <div class="product-banner">
        <img :src="detail.detail_banner" alt="" >
      </div>
      <div class="product-txt">
        <h3>{{ detail.name }}</h3>
        <h4>{{ detail.category.en_name }}</h4>
        <h5>{{ detail.name_content }}</h5>
      </div>
    </div>
    <div class="product-detail-list">
      <div class="product-detail-item" v-for="item in detail.detail_list">
        <div class="thumb">
          <img :src="item.image" class="lazyload" alt="" />
        </div>
        <div class="product-detail-item-info">
          <h5>{{ item.name }}</h5>
          <p>{{ item.content }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'detail-content',
  props: {
    detail: {
      type: Object,
      default: {}
    }
  },
  data(){
    return {

    }
  },
  mounted() {
  },
  methods: {

  }
}

</script>

<style scoped>

.pc-detail-content h1, .pc-detail-content h2, .pc-detail-content h3 {
  font-family: 'HarmonyOS_Sans_Bold', sans-serif;
  font-size: 20px;
  color: #1B1B1B ;
}

.pc-detail-content h4, .pc-detail-content h5 {
  font-family: 'HarmonyOS_Sans_SC_Medium', sans-serif;
  font-size: 20px;
  color: #1B1B1B ;
}
.pc-detail-content p {
  font-family: 'HarmonyOS_Sans_SC_Regular', sans-serif;
  font-size: 20px;
  color: #7d7d7d ;
  margin: 0;
  padding: 0;
}

.pc-detail-content .product-info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.pc-detail-content .product-info .product-txt {
  flex-grow: 1;
  padding-right: 88px;
}
.pc-detail-content .product-info .product-txt h3 {
  font-size: 60px;
  text-align: center;
  padding-bottom: 40px;
  font-weight: 500;
}
.pc-detail-content .product-info .product-txt h4 {
  font-size: 30px;
  text-align: center;
  padding-bottom: 40px;
  font-weight: 500;
}
.pc-detail-content .product-info .product-txt h5 {
  font-size: 20px;
  text-align: center;
  line-height: 1.8;
  font-weight: 500;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
}

.pc-detail-content .product-info .product-banner {
  width: 1110px;
  height: 870px;
  padding-left: 88px;
}
.pc-detail-content .product-info .product-banner img{
  width: 100%;
  height: 100%;
  display: block;
}


.product-detail-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0 88px;
  margin-top: 56px;
  margin-bottom: 101px;
}
.product-detail-list .product-detail-item {
  margin-top: 101px;
  width: 840px;
}

.product-detail-list .product-detail-item:nth-child(even) {
  margin-left: 60px;
}
.product-detail-list .product-detail-item .thumb,
.product-detail-list .product-detail-item .thumb img {
  width: 840px;
  height: 504px;
}
.product-detail-list .product-detail-item .product-detail-item-info {

}
.product-detail-list .product-detail-item .product-detail-item-info h5 {
  font-size: 24px;
  font-weight: 500;
  padding: 31px 0 24px 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
  line-height: 1.8;
}
.product-detail-list .product-detail-item .product-detail-item-info p {
  font-size: 16px;
  font-weight: 400;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
  line-height: 1.6;
}
</style>
